import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-08",
  "use": "icon-button_icon-08-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 24\" id=\"icon-button_icon-08\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M8 16.328V20l-7-6.5L8 7v3.736\" /><path d=\"M15 11H8M15 16H8\" /><path stroke-linejoin=\"round\" d=\"M18 11.328V15l7-6.5L18 2v3.736\" /><path d=\"M11 6h7M11 11h7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol